import React from 'react'
import {MotionCount} from '../../../helper/motionCount'

export const Card = ({title,value,icon}) => {
  return (
    <div className='bg-white py-2 px-2 rounded-md shadow-sm'>
        <div className='flex justify-between items-center'>
            <p className='text-sm font-semibold text-[#003049]'>
                {title}
            </p>
            <div className='mr-2'>
            <span className={`${icon} text-[24px]`}></span>
            </div>
        </div>
        <div>
            <span className='text-gray-500'>
                <MotionCount number={value} size="text-sm"/>
            </span>
        </div>
    </div>
  )
}
